import { render, staticRenderFns } from "./SubjectGoalIcons.vue?vue&type=template&id=ad44689c&scoped=true&"
import script from "./SubjectGoalIcons.ts?vue&type=script&lang=ts&"
export * from "./SubjectGoalIcons.ts?vue&type=script&lang=ts&"
import style0 from "./subject-goal-icons.scss?vue&type=style&index=0&id=ad44689c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad44689c",
  null
  
)

export default component.exports